import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';
import Detail from '../views/Detail.vue';
import AdminList from '../admin/AdminList.vue';
import AdminEdit from '../admin/AdminEdit.vue';

Vue.use(VueRouter);

const routes = [
  { path: '/', name: 'Home', component: Home },
  { path: '/detail/:id', name: 'Detail', component: Detail },
  { path: '/admin', name: 'AdminList', component: AdminList },
  { path: '/admin/edit/:id?', name: 'AdminEdit', component: AdminEdit }
];

const router = new VueRouter({
  mode: 'hash',
  routes
});

export default router;
